import React from "react";
import { useCartContext } from "../../cart";
import { useTenantContext } from "../../tenant/TenantContext";
import { ContainerTitle } from "../../components/Theme/theme.elements";
import { ContainerMenu, Totales, Valortotal, Valortotales } from "../../ui";
import { FormattedNumber } from "../../common/ui/FormattedNumber";

// todo: move to domain logic
const DeliveryCosts = ({ subtotal, deliveryCostThreshold, hasRefrigeratedProducts }) => {
    let text = "";
    let colorClass = "text-muted";

    if (subtotal >= deliveryCostThreshold) {
        text = "Envío gratuito.";
        colorClass = "text-success";
    } else if (hasRefrigeratedProducts) {
        text = "Coste envío 9,5€.";
        colorClass = "text-danger";
    } else {
        text = "Coste de envío para pedidos de menos de 10 kg es 5€. Para pedidos con más de 10kg es 9,5€.";
        colorClass = "text-danger";
    }

    return <small className={colorClass}>{text}</small>;
};

export const OrderRecap = () => {
    const { cart, loading } = useCartContext();
    const tenant = useTenantContext();

    // Default TRUE para no romper tenants que no tengan la clave
    const deliveryCostsEnabled = tenant?.deliveryCosts?.enabled ?? true;

    return loading ? (
        <div className="text-center m-4">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    ) : (
        !!cart && (
            <ContainerMenu className="filtroMacroFamilia">
                <ContainerTitle>Resumen de tu pedido</ContainerTitle>

                <Totales>Descuentos aplicables</Totales>
                <Valortotales>
                    <FormattedNumber value={cart.discount} config={{ style: "currency" }} />
                </Valortotales>

                <Totales>Total</Totales>
                <Valortotal>
                    <FormattedNumber value={cart.subtotal} config={{ style: "currency" }} />
                </Valortotal>

                <div className="d-flex flex-column mt-2 gap-1">
                    <small className="text-muted">
                        IVA no includo. Total con IVA: <FormattedNumber value={cart.total} config={{ style: "currency" }} />
                    </small>

                    {deliveryCostsEnabled && (
                        <DeliveryCosts
                            subtotal={cart.subtotal}
                            deliveryCostThreshold={120}
                            hasRefrigeratedProducts={cart.products.some(({ refrigerated }) => refrigerated)}
                        />
                    )}
                </div>
            </ContainerMenu>
        )
    );
};
